import { useState, useEffect } from 'react';
import axios from 'axios';
import config from '../config';

export default function useActivePeriod() {
    const [period, setPeriod] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios.get(`${config.apiUrl}/api/v1/active-period`)
            .then(res => setPeriod(res.data?.data || null))
            .catch(() => setPeriod(null))
            .finally(() => setLoading(false));
    }, []);

    const hasActivePeriod = !loading && !!period && period.status === 'active';

    return { period, loading, hasActivePeriod };
}
